import { Command } from './Command';
import { InsuredPatientCommandParams } from './InsuredPatientCommandParams';

export type GetPatientElectronicPrescriptionListParams =
	InsuredPatientCommandParams /* & {}*/;

export const GetPatientElectronicPrescriptionList = (
	params: GetPatientElectronicPrescriptionListParams,
): Command => {
	return {
		operation: 'VyhladajPreskripcnyZaznam_v6',
		params,
	};
};
